import React, { ChangeEvent, Component, useState } from "react";
import "./CreateContactModal.scss";
import OwButton from "../OwButton/OwButton";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import ISupplierModel from "../../../models/ISupplierModel";
import OwTitle from "../OwTitle/OwTitle";
import IUserUI from "../../../models/IUserUI";
import { OwFnInput } from "../OwFnInput/OwFnInput";
import OwLabel from "../OwLabel/OwLabel";

type Props = {
    closeModalFn: () => void;
    contactName?: string;
    createContact: (name: string, phone: string) => void;
};

export const CreateContactModal: React.FC<Props> = (props) => {
    const [contactName, setContactName] = useState(props.contactName || "");
    const [contactPhone, setContactPhone] = useState("");

    const closeModal = () => {
        props.closeModalFn();
    };

    const create = () => {
        props.createContact(contactName, contactPhone);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        if (name === "name") {
            setContactName(value);
        }

        if (name === "phone") {
            setContactPhone(value);
        }
    };

    return (
        <div className={"CreateContactModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-user"} title={"create_contact"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwLabel title={"name"} />
                    <OwFnInput fn={handleChange} name={"name"} value={contactName} />
                </div>

                <div>
                    <OwLabel title={"phone"} />
                    <OwFnInput fn={handleChange} name={"phone"} value={contactPhone} />
                </div>

                <div className="mt-3">
                    <OwButton title={"save"} fn={create} />
                </div>
            </div>
        </div>
    );
};
